import type { PbxLocationsLocale } from './en'

export const pbxLocationsKo = {
  header: `위치`,
  headerSubtext: `이 PBX의 사무실 위치를 관리합니다. 각 위치는 긴급 전화 발신 시 발신자 ID로 사용될 E911 전화번호에 연결됩니다.`,
  addLocation: `위치 추가`,
  searchPlaceholder: `위치 검색`,
  empty: `이 PBX에 아직 구성된 위치가 없습니다.`,
  loadError: `위치를 불러오지 못했습니다.`,
  column: {
    name: `이름`,
    extensionCount: `내선`,
    e911Number: `E911 번호`,
    e911Address: `E911 주소`,
    actions: `작업`,
  },
  notConfigured: `구성되지 않음`,
  notConfiguredE911Number: `할당된 E911 번호 없음`,
  notConfiguredE911Address: `등록된 E911 주소 없음`,
  edit: `편집`,
  delete: `삭제`,
  extensionCountLabel_one: `내선 {{count}}개`,
  extensionCountLabel_other: `내선 {{count}}개`,
  form: {
    createHeader: `위치 추가`,
    editHeader: `위치 편집`,
    nameLabel: `이름`,
    namePlaceholder: `e.g. Main Office`,
    nameRequired: `이름은 필수입니다`,
    phoneNumberLabel: `E911 전화번호`,
    phoneNumberPlaceholder: `전화번호 선택`,
    phoneNumberHelp: `이 번호의 E911 주소가 이 위치에서 발신되는 긴급 전화에 사용됩니다.`,
    noAvailableNumbers: `할당할 수 있는 전화번호가 없습니다.`,
    loadingAvailableNumbers: `사용 가능한 번호를 불러오는 중...`,
    cancel: `취소`,
    save: `저장`,
    create: `위치 생성`,
    update: `위치 업데이트`,
    createSuccess: `위치가 생성되었습니다.`,
    updateSuccess: `위치가 업데이트되었습니다.`,
    createError: `위치를 생성하지 못했습니다.`,
    updateError: `위치를 업데이트하지 못했습니다.`,
  },
  deleteModal: {
    header: `위치 삭제`,
    confirmMessage: `"{{name}}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
    reassignPrompt_one: `{{count}}개의 내선이 이 위치에 할당되어 있어 삭제하기 전에 다시 할당해야 합니다. 새 위치를 선택하세요:`,
    reassignPrompt_other: `{{count}}개의 내선이 이 위치에 할당되어 있어 삭제하기 전에 다시 할당해야 합니다. 새 위치를 선택하세요:`,
    reassignSelectPlaceholder: `대상 위치 선택`,
    noOtherLocations: `이 PBX에 다른 위치가 없습니다. 먼저 다른 위치를 생성하세요.`,
    cancel: `취소`,
    confirm: `삭제`,
    confirmReassign: `재할당 후 삭제`,
    success: `위치가 삭제되었습니다.`,
    error: `위치를 삭제하지 못했습니다.`,
  },
} satisfies PbxLocationsLocale
